module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._v("\r\n          Search By\r\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": _vm.branchRecordWithLoadSettlementData
    },
    model: {
      value: (_vm.branchFilter),
      callback: function($$v) {
        _vm.branchFilter = $$v
      },
      expression: "branchFilter"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), (_vm.form.planType == 'group') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Collection Center ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "collection_center_id",
      "label": "name",
      "options": _vm.collectionCenters,
      "placeholder": "Select Group",
      "required": ""
    },
    on: {
      "input": _vm.loadSettlementData
    },
    model: {
      value: (_vm.colC),
      callback: function($$v) {
        _vm.colC = $$v
      },
      expression: "colC"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Customer")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "Customer_name",
      "label": "name",
      "options": _vm.members,
      "placeholder": "Select Customer",
      "required": ""
    },
    on: {
      "input": _vm.loadSettlementDataWithCustomer
    },
    model: {
      value: (_vm.member),
      callback: function($$v) {
        _vm.member = $$v
      },
      expression: "member"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Settlement Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.settlementDate),
      expression: "form.settlementDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "settlementDate",
      "placeholder": "EMI Date"
    },
    domProps: {
      "value": (_vm.form.settlementDate)
    },
    on: {
      "change": _vm.loadSettlementDataWithSettlementDate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "settlementDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Settlement From")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.settlementStartDate),
      expression: "form.settlementStartDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "settlementStartDate",
      "placeholder": "Settlement Date From"
    },
    domProps: {
      "value": (_vm.form.settlementStartDate)
    },
    on: {
      "change": _vm.loadSettlementData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "settlementStartDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Settlement To")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.settlementEndDate),
      expression: "form.settlementEndDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "settlementEndDate",
      "placeholder": "Settlement Date To"
    },
    domProps: {
      "value": (_vm.form.settlementEndDate)
    },
    on: {
      "change": _vm.loadSettlementDataWithSettlementEndDate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "settlementEndDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('status'),
    },
    attrs: {
      "name": "status"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadSettlementData]
    }
  }, [(!_vm.form.status) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\r\n                    Select Status\r\n                  ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pending"
    }
  }, [_vm._v("Pending")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "approved"
    }
  }, [_vm._v("Approved")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "status"
    }
  })], 1)])])])]), _vm._v(" "), (_vm.canAccess('bank-view-any')) ? _c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('label', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.per_page),
      expression: "per_page"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "name": "per_page",
      "aria-controls": "example1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.per_page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.loadSettlementData()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('a', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "href": ((this.$axios.defaults.baseURL) + "/sattlement/export/excel")
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Download Excel\r\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group pull-right input-group-sm",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table_search),
      expression: "table_search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "table_search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.table_search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loadSettlementData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.table_search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadSettlementData()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.rows.data), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s((index + _vm.pagination.from)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.member_loan_plan.applicationNo))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.member.name) + " - " + _vm._s(row.member.code))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.member.alias))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.member.mobile))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.planAmount))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.totalAmountPaid))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.totalAmountDue))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.totalAmountPaidWithSettlement))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.sattlementDate)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.created_by.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.branch_ledger.ledger.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.status))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group"
    }, [(row.status !== 'approved') ? _c('button', {
      staticClass: "btn btn-success btn-xs",
      on: {
        "click": function($event) {
          return _vm.editModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-xs",
      on: {
        "click": function($event) {
          return _vm.viewModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _vm._v(" "), (_vm.canAccess('loan-disbursement-delete')) ? _c('button', {
      staticClass: "btn btn-danger btn-xs",
      on: {
        "click": function($event) {
          return _vm.deleteModal(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])])])
  }), 0)])]), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\r\n              Showing " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " entries\r\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.settlementDetails) ? _c('div', {
    staticClass: "card-body"
  }, [_c('ul', {
    staticClass: "todo-list ui-sortable",
    attrs: {
      "data-widget": "todo-list"
    }
  }, [(_vm.settlementDetails.branch) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Branch Name : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.branch.name) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.branch_ledger) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Payment Mode : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.branch_ledger.ledger.name) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Member Name : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member.name) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Member code : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member.code) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Member Alias : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member.alias) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Member Contact Number : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member.mobile) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Member Email : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member.email) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member_loan_plan) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan Application Number : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member_loan_plan.applicationNo) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member_loan_plan) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan EMI Start Date : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member_loan_plan.emiStartDate) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member_loan_plan) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan EMI End Date : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member_loan_plan.emiEndDate) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member_loan_plan) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan Type : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member_loan_plan.type) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.collection_center) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Collection Center : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.collection_center.name) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Plan amount : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.planAmount) + "\r\n                        ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Amount Paid : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalAmountPaid) + "\r\n                        ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('ul', {
    staticClass: "todo-list ui-sortable",
    attrs: {
      "data-widget": "todo-list"
    }
  }, [_c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Amount Due Without Interest : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalAmountDueWithoutInterest) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Amount Due : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalAmountDue) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Installment Paid : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalInstallmentPaid) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Installment Due : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalInstallmentDue) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan Pre Closing Charge Type : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.loanPreClosingChargeType) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("loanPreClosingCharge (%) : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.loanPreClosingCharge) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Reason : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.reason) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Settlement Date : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.sattlementDate) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Remark : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.remark) + "\r\n                      ")]), _vm._v(" "), (_vm.settlementDetails.created_by) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan Settled By : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.created_by.name) + "\r\n                      ")]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Amount Paid With Settlement : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalAmountPaidWithSettlement) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Settlement Status : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.status) + "\r\n                      ")])])])])])]), _vm._v(" "), _vm._m(5)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Select Status "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Settlement List")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr. No.")]), _vm._v(" "), _c('th', [_vm._v("Loan Id")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Mem Name")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("(C/O) Alias")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Mem Mob")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Plan Amt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Paid Amt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Due Amt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Settle Amt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Settle Date")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pay Mode")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Settlement Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e55c8e3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/Reports/SettlementReport.vue
// module id = 780
// module chunks = 0